import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import RulesBlock from "../../../../export/components/RulesBlock";
import type {ImportProfile, AttributeMappingRule} from "../../../../../types";
import type {ParsedField, RetailerAttribute} from "../../types";

// region TypeScript Interfaces
interface AttributeMapperProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    attributes: RetailerAttribute[];
    parsedFields: ParsedField[];
    profile: ImportProfile;
    setProfile: React.Dispatch<React.SetStateAction<ImportProfile>>;
    isRetailer?: boolean;
}
// endregion

export default function AttributeMapper(props: AttributeMapperProps) {
    const {open, setOpen} = props;
    const {attributes, parsedFields} = props;
    const {profile, setProfile} = props;

    const [formattedProfile, setFormattedProfile] = React.useState<{ Rules: AttributeMappingRule[] }>({
        Rules: profile.AttributeMappingRules.map(rule => {
            return {
                TargetField: rule.TargetField,
                SourceField: rule.SourceField,
                Condition: rule.Condition
            }
        })
    });

    const save = () => {
        setProfile({
            ...profile,
            AttributeMappingRules: formattedProfile.Rules.map(rule => {
                return {
                    TargetField: rule.TargetField,
                    SourceField: rule.SourceField,
                    Condition: rule.Condition
                }
            })
        });
        setOpen(false);
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth={"lg"} fullWidth={true}>
            <DialogTitle>
                Attribute Mapping Rules
            </DialogTitle>

            <DialogContent>
                <RulesBlock isRetailer={props.isRetailer}
                            type={"generic"}
                            targetOptions={attributes.map(attr => ({value: attr.Name, label: attr.FriendlyName}))}
                            sourceOptions={parsedFields.map(field => ({value: field.field, label: field.field}))}
                            profile={formattedProfile as any} setProfile={setFormattedProfile as any} attributes={[]} />
            </DialogContent>

            <DialogActions>
                <Button
                    variant={"outlined"}
                    onClick={() => setOpen(false)}
                >
                    Cancel
                </Button>

                <Button
                    variant={"outlined"}
                    onClick={() => save()}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}
